import moment from 'moment-timezone';

import acHTTPClient from 'services/ACHTTPClient';
import config from '../../../config/config';




const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;
const productSearchAPIURL = `${config.productSearchAPIURL}/api/v1`
const NotificationTypeMap = {
    'confirmation': 'AEX_CONF',
    'code': 'AEX_CODE'
}

const maxBookingCount = 5000;

export default  {
    maxBookingCount,
    getBookings: async (filter = {}) => {
        const limit = maxBookingCount;
        const request = {
            method: 'GET',
            url: `${experienceAPIURL}/bookings?limit=${limit}`
        };
        if (filter.page) { request.url += '&pageNumber=' + filter.page }
        if (filter.startDate) { request.url += '&from=' + moment(filter.startDate).toISOString() }
        if (filter.endDate) { request.url += '&to=' + moment(filter.endDate).toISOString() }
        if (filter.codeSent !== null && filter.codeSent !== undefined && filter.codeSent !=='') {request.url += '&isCodeSent=' + filter.codeSent}
        if (filter.countries) { request.url += '&' + filter.countries.map(c => 'countries=' + encodeURIComponent(c)).join('&') }
        if (filter.states) { request.url += '&' + filter.states.map(c => 'states=' + encodeURIComponent(c)).join('&') }
        if (filter.cities) { request.url += '&' + filter.cities.map(c => 'cities=' + encodeURIComponent(c)).join('&') }
        if (filter.status) { request.url += '&' + filter.status.map(c => 'bookingStatuses=' + encodeURIComponent(c)).join('&') }
        if (filter.category) {request.url += '&' + filter.category.map(c => 'category=' + encodeURIComponent(c)).join('&')}
        if (filter.owners) {request.url += '&' + filter.owners.map(c => 'userIds=' + encodeURIComponent(c)).join('&')}
        if (filter.providerItemStatus) {request.url += '&' + filter.providerItemStatus.map(c => 'routeStopItemsActivityStatuses=' + encodeURIComponent(c)).join('&')}
        if (filter.productName) { request.url += '&productName=' + encodeURIComponent(filter.productName)}
        const requiredFields = [
            'hqId',
            'product.id',
            'product.name',
            'userId',
            'bookingStatus',
            'hq.dateTime',
            'hq.adultsCount',
            'hq.timezone',
            'hq.kidsCount',
            'hq.customer.name',
            'hq.status',
            'hq.dietaries.allergy',
            'hq.extras.addOns',
            'subscriptionStatus',
            'route.name',
            'notification.lastCodeSent.isValid',
            'notes',
            'note',
            "alert",
            "alerts",
            "isPersonalisationDone",
            "product.wheres",
            // "bookingError",
            // "createdDateTime",
            // "deliveryStatus",
            "experiencePersonalisationDetails",
            // "hasError",
            // "hq",
            // "hqId",
            // "id",
            // "notification",
            // "product",
            // "productId",
            // "route",
            // "routeId",
            // "subscriptionStatus",
            // "subscriptionTier",
            // "updatedDateTime",
            // 'notes',
            // 'note',
            // "userId"
        ]
        request.url += '&selectfields=' + requiredFields.join('&selectfields=');
        return await acHTTPClient
            .request(request)
            .then((response) => {
                if (!response.data || response.data.error) {
                    console.error('Error fetching routes : Invalid response ', response);
                    return [];
                } else {
                    const data = response.data?.data;
                    return data.sort((a,b) => { return moment(a.bookingDate).isAfter(moment(b.bookingDate)) ? -1 : 1 });
                }
            })
            .catch((error) => {
                console.error('Error fetching routes : ', error)
                return [];
            });


    },
    getLocationData: async() => {
        const empty = { cities : [], countries : [] , states : []}
        let apiURL = `${experienceAPIURL}/options`;
          const config = { url: apiURL, method: 'GET' };
          return await acHTTPClient
            .request(config)
            .then(response => {
              if (!response.data || response.data.error) {
                console.error('Error fetching routes : Invalid response ', response);
                return empty
              } else {
                  return response.data?.data || empty;
              }
            })
            .catch(error => {
                console.error('Error fetching location data : ', error)
                return empty;
            });
      
    },
    getRoutes: async (filter) => {

        const request = {
            method: 'GET',
            url: `${experienceAPIURL}/routes?limit=500`
        };
        return await acHTTPClient
            .request(request)
            .then((response) => {
                if (!response.data || response.data.error) {
                    console.error('Error fetching routes : Invalid response ', response);
                    return [];
                } else {
                    const data = response.data?.data || [];
                    return data;
                }
            })
            .catch((error) => {
                console.error('Error fetching routes : ', error)
            });
    },
    getStaff: async() => {
        const url = `${experienceAPIURL}/users`;
        const request = { method: 'GET', url };
        return await acHTTPClient.request(request)
                .then(response => {
                    if (!response.data || response.data.error) {
                        console.error('Error fetching staff : Invalid response ', response);
                        return [];
                    } else {
                        const data = response.data?.data || [];
                        return data;
                    }
                })
                .catch(error => {
                    console.error('Error fetching staff list ')
                    return [];
                });

    },
    getProducts: async(query = '') => {
        const url = `${productSearchAPIURL}/products/search-collection?query=${query}&projections=location`;
        const request = { method: 'GET', url };
        return await acHTTPClient.request(request)
                .then(response => {
                    if (!response.data || response.data.error) {
                        console.error('Error fetching products : Invalid response ', response);
                        return [];
                    } else {
                        const data = response.data?.data || [];
                        return data;
                    }
                })
                .catch(error => {
                    console.error('Error fetching products list ')
                    return [];
                });
    },
    putBookingManager : async (bookingId, userId) => {
        const config = {};
        if (userId) {
            config.url = `${experienceAPIURL}/bookings/${bookingId}/users/${userId}`;
            config.method = 'PUT';
        } else {
            config.url = `${experienceAPIURL}/bookings/${bookingId}/users`;
            config.method = 'DELETE';
        }
          
          return await acHTTPClient.request(config)
            .then((response) => {
              if (!response.data || response.data.error) {
                return Promise.reject(response.data?.error || 'Server returned an invalid response')
              }
              console.log('Put Booking : ', { bookingId, userId, response : response.data})
              return response.data;
            })
            .catch((error) => {
                console.error('putBookingManager Error : ', error)
                return Promise.reject(error);
            });
      },
      sendBulkGamePlay : async (bookingList, actor) => {
        const body = bookingList.map((booking) => {
            return {
                notificationType: NotificationTypeMap.code,
                bookingId: booking.id,
                actor
            };
        });
        
        const config = {
            url:`${experienceAPIURL}/bookings/delivery-status/queue/bulk`,
             method:'POST',
             data: body
         }

         return await acHTTPClient.request(config)
         .then((response) => {
           if (!response.data || response.data.error) {
             return Promise.reject(response.data?.error || 'Server returned an invalid response')
           }
           return response.data;
         })
         .catch((error) => {
             console.error('sendBulkGamePlay Error : ', error)
             return Promise.reject(error);
         });
      },
      getBookingNotificationData: async (bookingId) => {
        const config = {
            url:`${experienceAPIURL}/bookings/${bookingId}/notification`,
             method:'GET'
         }

         return await acHTTPClient.request(config)
         .then((response) => {
           if (!response.data || response.data.error) {
             return Promise.reject(response.data?.error || 'Server returned an invalid response')
           }
           return response.data;
         })
         .catch((error) => {
             console.error('bookign notification data Error : ', error)
             return Promise.reject(error);
         });
      },

}